import React from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';

import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import SelectAddSubjects from '../../components/select-add-subjects/SelectAddSubjects';
import RouteKey from '../../routes/key';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';

interface AddSubjectPageProps {
  routeSteps: { label: string }[];
  isGroup?: boolean;
}

const {
  examRegistrations,
  reviewSubjects,
  coordinatorExamRegistrations,
  coordinatorReviewSubjects,
} = RouteKey.amendment.child;
const { amendment } = RouteKey.child;

const AddSubjectPage = ({ routeSteps, isGroup = false }: AddSubjectPageProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { uuid: applicationUUID } = useParams<any>();

  const title = isGroup
    ? t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')
    : 'Subject Amendment';
  const activeStep: number = isGroup ? 2 : 1;
  const nextUrl = isGroup
    ? `/${amendment}/${coordinatorExamRegistrations.route}/${coordinatorReviewSubjects.route}/${applicationUUID}`
    : `/${amendment}/${examRegistrations.route}/${applicationUUID}/${reviewSubjects.route}`;

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        {isGroup && <ExamTypeUuidDisplay />}
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <SelectAddSubjects
        title={t('exam->>SelectSubjects.Add Subject')}
        enable
        description={t(
          'amendment->>AddSubject.Below are the subjects and papers that are eligible for registration.'
        )}
        toNavigation={{
          onRouting: () => history.push(nextUrl),
          label: t('amendment->>AddSubject.Proceed to Review Subject(s)'),
        }}
        backNavigation={{
          onRouting: () => history.goBack(),
          label: t('amendment->>AddSubject.Back'),
        }}
        confirmRouteAndLabel={{
          confirmRoute: nextUrl,
          confirmLabel: t('amendment->>AddSubject.Proceed to Review Subject(s)'),
        }}
      />
    </>
  );
};

export default AddSubjectPage;
